theme.readMore = (function(){
  const selectors = {
    wrapper: '.read-more__wrapper',
    link: '.read-more__link',
    content: '.read-more__content',
    expandedClass: 'read-more__content--expanded'
  }

  const init = () => {
    let wrappers = document.querySelectorAll(selectors.wrapper);
    wrappers.forEach(wrapper => {
      let link = wrapper.querySelector(selectors.link);
      link.addEventListener('click', function(e){
        e.preventDefault();
        wrapper.classList.toggle(selectors.expandedClass);
        link.textContent = wrapper.classList.contains(selectors.expandedClass) ? 'Read Less' : 'Read More';
      });
    })
  }

  return {
    selectors,
    init
  }
})();